
import { DrinkOption } from '../../types';
import DrinkCard from './DrinkCard';

const drinks: DrinkOption[] = [
  {
    id: 'biscoff-latte',
    name: 'Biscoff Latte',
    description: 'Silky espresso kissed with caramelized cookie warmth'
  },
  {
    id: 'rose-latte',
    name: 'Rose Latte',
    description: 'Delicate petals dancing through velvety steamed milk'
  },
  {
    id: 'vanilla-bean',
    name: 'Madagascar Vanilla Bean',
    description: 'Pure vanilla essence from distant shores, rich and aromatic'
  },
  {
    id: 'fleur-de-lait',
    name: 'Fleur de Lait',
    description: 'French-inspired milk flower, light as morning mist'
  },
  {
    id: 'london-fog',
    name: 'London Fog',
    description: 'Tea-clouded comfort with rose or lavender whispers',
    hasFlavorChoice: true
  },
  {
    id: 'honey-vanilla',
    name: 'Honey Vanilla Latte',
    description: 'Golden sweetness meets Madagascar vanilla in perfect harmony'
  }
];

interface MenuProps {
  onAddToCart: (
    drink: DrinkOption,
    milk: 'Whole Milk' | 'Oat Milk',
    temperature: 'Hot' | 'Iced',
    quantity: number,
    flavor?: 'Rose' | 'Lavender'
  ) => void;
}

export default function Menu({ onAddToCart }: MenuProps) {
  return (
    <section id="menu" className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-script text-navy mb-4">
            Menu
          </h2>
          <p className="text-lg text-navy/70 max-w-2xl mx-auto">
            Handcrafted beverages made with love, served with neighborhood warmth
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {drinks.map((drink) => (
            <DrinkCard
              key={drink.id}
              drink={drink}
              onAddToCart={onAddToCart}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
